/*
 * File: index.ts
 * Project: meki
 * File Created: Friday, 2nd October 2020 5:37:15 pm
 * Author: Luis Aparicio (luis@inventures.cl)
 * -----
 * Last Modified: Friday, 2nd October 2020 5:45:21 pm
 * Modified By: Luis Aparicio (luis@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */

export * from './addressBase';
export * from './addressUser';
